import styled from 'styled-components';

export const TagWrapper = styled.span`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.black1};
  display: inline-flex;
  padding: 2px 6px;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-left: 8px;
`;
